webpackJsonp([122355344463645],{

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ProjectPage = __webpack_require__(9);
	
	var _ProjectPage2 = _interopRequireDefault(_ProjectPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var projectElements = {
		images: [{
			"src": "Stadthimmel/city_1",
			"orientation": "landscape"
		}, {
			"src": "Stadthimmel/city_2",
			"orientation": "landscape"
		}, {
			"src": "Stadthimmel/city_3",
			"orientation": "landscape"
		}, {
			"src": "Stadthimmel/city_4",
			"orientation": "landscape"
		}]
	};
	
	var Stadthimmel = function (_React$Component) {
		_inherits(Stadthimmel, _React$Component);
	
		function Stadthimmel() {
			_classCallCheck(this, Stadthimmel);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		Stadthimmel.prototype.render = function render() {
			return _react2.default.createElement(_ProjectPage2.default, {
				title: 'Stadthimmel',
				text: 'Die Fotoserie ist zwei Entwicklungsstufen durchgangen. Beide konzentrierten sich jedoch auf eine oder mehrere Linien. W\xE4hrend einem Spaziergang durch die Stadt fielen mir die Kabel der Stra\xDFenlampen auf, welche den Blick zum Himmel versperren. Die Fotoserie besteht aus vier sich wiederholenden Fotos welche viermal abweichend zusammengestellt wurden um eine verbundene  Linie zu ergeben.Im Jahr 2016 haben wir gemeinsam als Klasse eine Ausstellung mit dem Titel  \u201EBorderline\u201C organisiert. Als Teil  ieser Ausstellung ist die Fotoserie \u201EStadthimmel\u201C entstanden. F\xFCr die einzelnen Werke mussten sich die K\xFCnstler f\xFCr eine  Pr\xE4sentationsform entscheiden. F\xFCr meine Aufh\xE4ngung entschied ich mich f\xFCr eine gro\xDFe Pinnwand, welche mir die M\xF6glichkeit gab,  die Zusammenstellung der Fotos flexibel zu \xE4ndern.',
				images: projectElements.images,
				layout: 'einser' });
		};
	
		return Stadthimmel;
	}(_react2.default.Component);
	
	exports.default = Stadthimmel;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-citysky-js-f8eefb477c8580311308.js